import React, { useState, useEffect } from 'react';
import { Box, Typography } from '@mui/material';

function AIWriterMessage({
    messages = [],
    speed = 30,
    fontSize = 14,
    color = 'text.secondary',
    onComplete = null,
}) {
    const [currentMessageIndex, setCurrentMessageIndex] = useState(0);
    const [currentText, setCurrentText] = useState('');
    const [completedMessages, setCompletedMessages] = useState([]);
    const [hasCompleted, setHasCompleted] = useState(false);

    useEffect(() => {
        // Resetear al cambiar mensajes
        setCurrentMessageIndex(0);
        setCurrentText('');
        setCompletedMessages([]);
        setHasCompleted(false);
    }, [messages]);

    useEffect(() => {
        if (currentMessageIndex >= messages.length) {
            // Todos los mensajes completados, llamar callback si existe
            if (!hasCompleted && onComplete) {
                setHasCompleted(true);
                onComplete();
            }
            return;
        }

        const fullMessage = messages[currentMessageIndex] || '';
        const currentLength = currentText.length;

        if (currentLength < fullMessage.length) {
            // Escribir siguiente carácter
            const timer = setTimeout(() => {
                setCurrentText(fullMessage.substring(0, currentLength + 1));
            }, speed);

            return () => clearTimeout(timer);
        } else {
            // Mensaje actual completado, pasar al siguiente después de una pausa
            const timer = setTimeout(() => {
                if (fullMessage) {
                    setCompletedMessages((prev) => [...prev, fullMessage]);
                }
                setCurrentText('');
                setCurrentMessageIndex((prev) => prev + 1);
            }, 500); // Pausa de 500ms entre mensajes

            return () => clearTimeout(timer);
        }
    }, [currentText, currentMessageIndex, messages, speed, hasCompleted, onComplete]);

    return (
        <Box>
            {/* Mensajes completados */}
            {completedMessages.map((message, index) => {
                const isLast = index === messages.length - 1 && currentMessageIndex >= messages.length;
                return (
                    <Typography key={index} fontSize={fontSize} color={color} sx={{ mb: isLast ? 0 : 1 }}>
                        {message}
                    </Typography>
                );
            })}

            {/* Mensaje actual siendo escrito */}
            {currentMessageIndex < messages.length && currentText && (
                <Typography
                    fontSize={fontSize}
                    color={color}
                    sx={{ mb: currentMessageIndex === messages.length - 1 ? 0 : 1 }}
                >
                    {currentText}
                    <span style={{ opacity: 0.5, animation: 'blink 1s infinite' }}>|</span>
                </Typography>
            )}

            {/* Keyframes para el cursor parpadeante */}
            <style>
                {`
                    @keyframes blink {
                        0%, 50% { opacity: 1; }
                        51%, 100% { opacity: 0; }
                    }
                `}
            </style>
        </Box>
    );
}

export default AIWriterMessage;
